var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.17,
    y: 123,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.17,
    y: 123,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.17,
    y: 123,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.17,
    y: 123,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.17,
    y: 230,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.17,
    y: 230,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.17,
    y: 230,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.17,
    y: 230,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.17,
    y: 337,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.17,
    y: 337,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-11--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.17,
    y: 337,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-12--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.17,
    y: 337,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-13--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.71,
    y: 183.05,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "#FB8CFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-14--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.35,
    y: 367.69,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "#FB8CFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-15--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.37,
    y: 367.69,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "#FB8CFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-16--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.37,
    y: 367.69,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "#FB8CFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-17--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.53,
    y: 275.3,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "#FB8CFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-18--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.53,
    y: 275.3,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "#FB8CFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.19,71.92S91.42,110.52,53.63,170,18.83,306,64.75,362.8s133.69,49.34,207.18,85.32,154.57,28.57,189.32-47.66S443.6,295.74,434.6,207.52,346.07-9.88,167.19,71.92Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.19,71.92S91.42,110.52,53.63,170,18.83,306,64.75,362.8s133.69,49.34,207.18,85.32,154.57,28.57,189.32-47.66S443.6,295.74,434.6,207.52,346.07-9.88,167.19,71.92Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--boxes-2--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.17,
    y: 123,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.17,
    y: 123,
    width: 85.88,
    height: 77.99,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 85.17,
    y: 123,
    width: 61.2,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.83,
    y: 123,
    width: 13.15,
    height: 21.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.34,
    y: 151.13,
    width: 15.24,
    height: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.51,
    y: 176.75,
    width: 16.18,
    height: 9.64,
    transform: "translate(47.26 -24.61) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.17,
    y: 123,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.17,
    y: 123,
    width: 85.88,
    height: 77.99,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 149.17,
    y: 123,
    width: 61.2,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.83,
    y: 123,
    width: 13.15,
    height: 21.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.34,
    y: 151.13,
    width: 15.24,
    height: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.51,
    y: 176.75,
    width: 16.18,
    height: 9.64,
    transform: "translate(49.13 -39.98) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.17,
    y: 123,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.17,
    y: 123,
    width: 85.88,
    height: 77.99,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 213.17,
    y: 123,
    width: 61.2,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.83,
    y: 123,
    width: 13.15,
    height: 21.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.34,
    y: 151.13,
    width: 15.24,
    height: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.51,
    y: 176.75,
    width: 16.18,
    height: 9.64,
    transform: "translate(51 -55.35) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.17,
    y: 123,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.17,
    y: 123,
    width: 85.88,
    height: 77.99,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 277.17,
    y: 123,
    width: 61.2,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.83,
    y: 123,
    width: 13.15,
    height: 21.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.34,
    y: 151.13,
    width: 15.24,
    height: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.51,
    y: 176.75,
    width: 16.18,
    height: 9.64,
    transform: "translate(52.88 -70.72) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.17,
    y: 230,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.17,
    y: 230,
    width: 85.88,
    height: 77.99,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 85.17,
    y: 230,
    width: 61.2,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.83,
    y: 230,
    width: 13.15,
    height: 21.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.34,
    y: 258.13,
    width: 15.24,
    height: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.51,
    y: 283.75,
    width: 16.18,
    height: 9.64,
    transform: "translate(72.95 -21.48) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.17,
    y: 230,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.17,
    y: 230,
    width: 85.88,
    height: 77.99,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 149.17,
    y: 230,
    width: 61.2,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.83,
    y: 230,
    width: 13.15,
    height: 21.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.34,
    y: 258.13,
    width: 15.24,
    height: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.51,
    y: 283.75,
    width: 16.18,
    height: 9.64,
    transform: "translate(74.83 -36.85) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.17,
    y: 230,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.17,
    y: 230,
    width: 85.88,
    height: 77.99,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 213.17,
    y: 230,
    width: 61.2,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.83,
    y: 230,
    width: 13.15,
    height: 21.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.34,
    y: 258.13,
    width: 15.24,
    height: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.51,
    y: 283.75,
    width: 16.18,
    height: 9.64,
    transform: "translate(76.7 -52.22) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.17,
    y: 230,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.17,
    y: 230,
    width: 85.88,
    height: 77.99,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 277.17,
    y: 230,
    width: 61.2,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.83,
    y: 230,
    width: 13.15,
    height: 21.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.34,
    y: 258.13,
    width: 15.24,
    height: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.51,
    y: 283.75,
    width: 16.18,
    height: 9.64,
    transform: "translate(78.57 -67.59) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.17,
    y: 337,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.17,
    y: 337,
    width: 85.88,
    height: 77.99,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 85.17,
    y: 337,
    width: 61.2,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.83,
    y: 337,
    width: 13.15,
    height: 21.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.34,
    y: 365.13,
    width: 15.24,
    height: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.51,
    y: 390.75,
    width: 16.18,
    height: 9.64,
    transform: "translate(98.65 -18.35) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.17,
    y: 337,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-10--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.17,
    y: 337,
    width: 85.88,
    height: 77.99,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 149.17,
    y: 337,
    width: 61.2,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.83,
    y: 337,
    width: 13.15,
    height: 21.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.34,
    y: 365.13,
    width: 15.24,
    height: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.51,
    y: 390.75,
    width: 16.18,
    height: 9.64,
    transform: "translate(100.53 -33.72) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.17,
    y: 337,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-11--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.17,
    y: 337,
    width: 85.88,
    height: 77.99,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 213.17,
    y: 337,
    width: 61.2,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.83,
    y: 337,
    width: 13.15,
    height: 21.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.34,
    y: 365.13,
    width: 15.24,
    height: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.51,
    y: 390.75,
    width: 16.18,
    height: 9.64,
    transform: "translate(102.4 -49.09) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.17,
    y: 337,
    width: 85.88,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-12--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.17,
    y: 337,
    width: 85.88,
    height: 77.99,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 277.17,
    y: 337,
    width: 61.2,
    height: 77.99,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.83,
    y: 337,
    width: 13.15,
    height: 21.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.34,
    y: 365.13,
    width: 15.24,
    height: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.51,
    y: 390.75,
    width: 16.18,
    height: 9.64,
    transform: "translate(104.27 -64.46) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 94.34,
    width: 300,
    height: 14,
    style: {
      fill: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 198.34,
    width: 300,
    height: 14,
    style: {
      fill: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 302.33,
    width: 300,
    height: 14,
    style: {
      fill: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 406.33,
    width: 300,
    height: 14,
    style: {
      fill: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 35.34,
    width: 13,
    height: 425,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 35.34,
    width: 13,
    height: 425,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 94.34,
    width: 61,
    height: 14,
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 198.34,
    width: 61,
    height: 14,
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 302.33,
    width: 61,
    height: 14,
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 406.33,
    width: 61,
    height: 14,
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 35.34,
    width: 13,
    height: 425,
    style: {
      fill: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 35.34,
    width: 13,
    height: 425,
    style: {
      fill: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 35.34,
    width: 13,
    height: 425,
    style: {
      fill: "#a3a3a3"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--boxes-1--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.71,
    y: 183.05,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-13--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.71,
    y: 183.05,
    width: 102.02,
    height: 92.64,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 242.71,
    y: 183.05,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.71,
    y: 183.05,
    width: 72.71,
    height: 92.64,
    style: {
      fill: "#FB8CFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.81,
    y: 183.05,
    width: 15.62,
    height: 25.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.43,
    y: 216.46,
    width: 18.11,
    height: 9.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.93,
    y: 246.9,
    width: 19.22,
    height: 11.46,
    transform: "translate(69.15 -62.15) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.35,
    y: 367.69,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-14--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.35,
    y: 367.69,
    width: 102.02,
    height: 92.64,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 181.35,
    y: 367.69,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.35,
    y: 367.69,
    width: 72.71,
    height: 92.64,
    style: {
      fill: "#FB8CFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.45,
    y: 367.69,
    width: 15.62,
    height: 25.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.42,
    y: 443.61,
    width: 18.11,
    height: 9.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.27,
    y: 398.52,
    width: 19.22,
    height: 11.46,
    transform: "translate(103.94 -44.34) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.37,
    y: 367.69,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-15--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.37,
    y: 367.69,
    width: 102.02,
    height: 92.64,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 256.37,
    y: 367.69,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.37,
    y: 367.69,
    width: 72.71,
    height: 92.64,
    style: {
      fill: "#FB8CFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.47,
    y: 367.69,
    width: 15.62,
    height: 25.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.09,
    y: 401.11,
    width: 18.11,
    height: 9.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.59,
    y: 392.24,
    width: 19.22,
    height: 11.46,
    transform: "translate(103.52 -53.49) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.37,
    y: 367.69,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-16--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.37,
    y: 367.69,
    width: 102.02,
    height: 92.64,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 332.37,
    y: 367.69,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.37,
    y: 367.69,
    width: 72.71,
    height: 92.64,
    style: {
      fill: "#FB8CFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.47,
    y: 367.69,
    width: 15.62,
    height: 25.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.09,
    y: 401.11,
    width: 18.11,
    height: 9.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.59,
    y: 392.24,
    width: 19.22,
    height: 11.46,
    transform: "translate(105.74 -71.74) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.53,
    y: 275.3,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-17--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.53,
    y: 275.3,
    width: 102.02,
    height: 92.64,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 216.53,
    y: 275.3,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.53,
    y: 275.3,
    width: 72.71,
    height: 92.64,
    style: {
      fill: "#FB8CFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.62,
    y: 275.3,
    width: 15.62,
    height: 25.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.25,
    y: 308.72,
    width: 18.11,
    height: 9.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.74,
    y: 299.85,
    width: 19.22,
    height: 11.46,
    transform: "translate(80.16 -46.62) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.53,
    y: 275.3,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-18--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.53,
    y: 275.3,
    width: 102.02,
    height: 92.64,
    style: {
      opacity: 0.37
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 297.53,
    y: 275.3,
    width: 102.02,
    height: 92.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.53,
    y: 275.3,
    width: 72.71,
    height: 92.64,
    style: {
      fill: "#FB8CFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.62,
    y: 275.3,
    width: 15.62,
    height: 25.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.25,
    y: 308.72,
    width: 18.11,
    height: 9.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.24,
    y: 321.75,
    width: 19.22,
    height: 11.46,
    transform: "translate(87.92 -66.51) rotate(13.9)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 38.4,
    y1: 460.33,
    x2: 476.4,
    y2: 460.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.2,430.47S112,439,109,443.82s-8.57,11.16-8,16.74,6.38,6.18,12.36,3,11.36-9.56,13-14.35,6.78-8.77,6.78-14.15-.4-6-2.39-6.58S118.19,427.08,116.2,430.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.14,435.05c0-.79,0-1.47,0-2.07a37.73,37.73,0,0,1-2,4.86c-2.2,4.39-5.39,7-6.58,12.36s-8.77,11.56-15.35,13.15-8-3.78-8-3.78l-.24,0a6.85,6.85,0,0,0,0,1c.6,5.58,6.38,6.18,12.36,3s11.36-9.56,13-14.35S133.14,440.43,133.14,435.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,434.05s2.4,3.39,10.37,2.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.8,436.85a11.49,11.49,0,0,0,8.37,2.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,439.24a8.23,8.23,0,0,0,7,2.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.2,442.63s1.4,2.79,6.78,2.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.22,438a33.82,33.82,0,0,0,12,11.36c7.77,4.19,17.74,7,18.53,9a3.35,3.35,0,0,1-1.19,4.19c-1,.59-15.75,1-23.52-.4a55.57,55.57,0,0,0-13.35-1.2c-3.59,0-11.36,1-12.36-3.39s1.59-20.33,1.59-20.33S160.64,440.63,167.22,438Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.52,462.56a3.28,3.28,0,0,0,1.44-3.18,65.67,65.67,0,0,1-9.41,1.58c-8,.8-19.93-1.79-29.3-2.19-6.88-.29-10.64-1.88-12.15-2.69a10.33,10.33,0,0,0,.19,1.49c1,4.39,8.77,3.39,12.36,3.39a55.57,55.57,0,0,1,13.35,1.2C180.77,463.55,195.52,463.15,196.52,462.56Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.21,442.63a12.65,12.65,0,0,0-3.59,4.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.6,445.61s-2.59,2.2-2.59,3.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.19,447.61a16.52,16.52,0,0,0-1.59,3.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.18,449.4s-1.6,1.4-1.6,2.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.93,226.33s-6.34,30.17-5.84,46.67,23,57.5,23,57.5-12,29.5-12.5,42.5.52,54.85.52,54.85,5,2.9,9.53,2.9,9.94-2.28,9.94-2.28l11.51-45,.5,54.5a21.48,21.48,0,0,0,11,3,19.4,19.4,0,0,0,11-3.5s8-57.5,9-67,7.5-38,8-40,10-33.5,10-59-7.33-40.83-7.33-40.83-25.67-5.67-44.67-6.17A203.9,203.9,0,0,0,110.93,226.33Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.59,376s13-37,13-46-8.5-65-8.5-65",
    style: {
      fill: "none",
      stroke: "#878787",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.59,282s7.5-8.5,10-13.5",
    style: {
      fill: "none",
      stroke: "#878787",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.26,149.67s10.33,6,16,15,18,47,17.33,56.66-3.66,12.34-12.33,10.67-9.33-11.33-11.33-19.33S185.26,154,185.26,154l-.33-4.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59,221.33c.34-4.92-2.69-17.2-6.5-29.25L194,195c1.77,8.2,3.29,15.09,3.93,17.64,2,8,2.66,17.66,11.33,19.33S220.93,231,221.59,221.33Z",
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.26,146.67s-8,1.66-10,15.66,2.67,37,2.67,37l-1,27s33.33,8.67,47,8.67,31.33-4.33,31.33-4.33-7.33-67.34-8.67-73-7.33-11.34-12.33-15-17.67-3.34-25-1.34-17.67,6-17.67,6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.26,137.33s7,28.34,7.67,47.67-3,79.33-3,79.33-15.67.67-27-1.33-19.34-3-19.34-3l10-62.33s13.67,1,16.67-8.67-1-29-4.67-35-4.33-7.33-4.33-7.33Z",
    style: {
      fill: "#FB8CFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.59,163.67s7.34,28,6.67,56-1,43-1,43,16-1,25-4.67c0,0-5-65.33-9.67-84.67s-6.33-23.66-6.33-23.66L169.59,142Z",
    style: {
      fill: "#FB8CFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.44,131.89s-7,1.3-8.84,4.94,7.28,33.54,7.28,33.54l13.26-10.92,16.38,9.36s-3.12-22.62-9.88-30.42S150.44,131.89,150.44,131.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.58,112.92s-.26,26.25,2.6,33,10.4,16.64,13.26,15.08,3.64-20.54,4.16-21.84,2.6-12,2.6-12S151.48,122,147.58,112.92Z",
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.58,112.92s-.1,10.54.55,20a18.61,18.61,0,0,0,11.76,6.44,23.66,23.66,0,0,0,7.69-.1.19.19,0,0,1,0-.07c.52-1.3,2.6-12,2.6-12S151.48,122,147.58,112.92Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.83,203.24l-2,1.22-11.57-18.91a1.17,1.17,0,0,1,.39-1.6h0a1.16,1.16,0,0,1,1.6.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.26,146.67s-7.67.66-12.33,9.66-12,51.34-13.34,63.67,6,11.33,7,11.33,54-17.66,54-17.66l18-2s-2,1.66-.33,1.66,5-3.33,6.33-5.33-4-13-6-14.33-20,12-20,12l-35,2.33,9-30.67",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.59,193.67c-2-1.34-20,12-20,12l-35,2.33,2.22-7.56-22.39-5.05c-1.85,10.27-3.3,19.76-3.83,24.61-1.33,12.33,6,11.33,7,11.33s54-17.66,54-17.66l18-2s-2,1.66-.33,1.66,5-3.33,6.33-5.33S174.59,195,172.59,193.67Z",
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.59,193.67c-2-1.34-20,12-20,12l-5.1.34a19.21,19.21,0,0,0,2.31,9.25l4.79-1.59,18-2s-2,1.66-.33,1.66,5-3.33,6.33-5.33S174.59,195,172.59,193.67Z",
    style: {
      fill: "#666",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.26 178 156.26 225.67 200.93 224 233.26 180 190.26 178",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.27 176.6 202.66 180.94 222.21 181.38 224.82 177.03 205.27 176.6",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.48,205.05a19.87,19.87,0,0,1-4.76,1.1c-2,.09-3.84,1.1-3.84,2.11s3.57,1.19,6.13,1.19,4.57-.55,5-2.2S220.86,204.14,218.48,205.05Z",
    style: {
      fill: "#666",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.78,200.58a25.31,25.31,0,0,1-6,1.4c-2.55.11-4.87,1.39-4.87,2.66s4.52,1.51,7.77,1.51,5.8-.69,6.38-2.78S223.8,199.42,220.78,200.58Z",
    style: {
      fill: "#666",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.63,196.76a25.31,25.31,0,0,1-6,1.4c-2.56.11-4.88,1.39-4.88,2.66s4.53,1.51,7.78,1.51,5.8-.69,6.38-2.78S225.65,195.6,222.63,196.76Z",
    style: {
      fill: "#666",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.88,192.44a25.51,25.51,0,0,1-6,1.39c-2.55.11-4.87,1.39-4.87,2.67s4.52,1.51,7.77,1.51,5.8-.7,6.38-2.79S226.9,191.28,223.88,192.44Z",
    style: {
      fill: "#666",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.08,418.32s-.21,10.36.2,12,7.67,3.72,12.22,3.72,7.46-1,8.29-2.27,2.27-9.74,2.27-9.74S121.91,425.37,115.08,418.32Z",
    style: {
      fill: "#666",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,104.6a19.5,19.5,0,0,0-19.23,3.64c-9.1,7.8-1,21.84,8.58,23.4s15.85-2.86,17.41-9.88S143.74,104.34,138,104.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,102.26s-1.3,13-3.9,22.1-9.36,12.48-19,11.18-15.08-9.1-18.2-18.2-3.38-21.58-3.38-21.58Z",
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.88,102S144,104.86,151,99.92s3.64-7.28,3.64-7.28l-16.64,1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.64,105.38s-1.3,3.9-.52,5.2,2.86,3.12.52,5.2a3.77,3.77,0,0,1-6-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.14,117s4,5.19,11.58,2.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.8,106.94c0,1.44-.58,2.6-1.3,2.6s-1.3-1.16-1.3-2.6.58-2.6,1.3-2.6S164.8,105.5,164.8,106.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.1,109c0,1.44-.58,2.6-1.3,2.6s-1.3-1.16-1.3-2.6.58-2.6,1.3-2.6S179.1,107.58,179.1,109Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.34,101.22s3.64-4.16,8.32,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,103.3a4.33,4.33,0,0,1,5.46.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,96.8l48.36,5.2s-.52-24.44-.78-28.59-19.5-9.88-27-9.36-16.9,4.94-18.46,7S137,96.8,137,96.8Z",
    style: {
      fill: "#FB8CFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.78,99.4l42.89,5.72s-11.43-9.88-20.53-10.66S157.78,99.4,157.78,99.4Z",
    style: {
      fill: "#FB8CFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.7,103.82s-1-8.06-5.46-8.06-2.34,6.5-1.82,10.66,5.46,5.2,7.28,3.64",
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.18,429.09l.62,9.74s2.75,2.06,10.79,2.17,11-3.5,11-3.5L171.2,427S156.29,434.06,147.18,429.09Z",
    style: {
      fill: "#666",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecking);
export default __webpack_public_path__ + "static/media/Checking.23973fa8540c739d37b6ffac2317b36b.svg";
export { ForwardRef as ReactComponent };